import { TRANSLATION_CONSTANTS as T } from './translations';
export enum ErrorCodes {
  NAMESPACE_ERROR = 'NAMESPACE_ERROR',
  USER_LICENSE_EXPIRED = 'USER_LICENSE_EXPIRED',
  RESOURCE_NOT_FOUND_ERROR = 'RESOURCE_NOT_FOUND_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  NO_PERMISSIONS_AGAINST_RESOURCE_ERROR = 'NO_PERMISSIONS_AGAINST_RESOURCE_ERROR',
  INSUFFICIENT_PRIVILEGES = 'INSUFFICIENT_PRIVILEGES',
  APP_ROLE_TEMPLATE_NOT_FOUND_ERROR = 'APP_ROLE_TEMPLATE_NOT_FOUND_ERROR',
  UPLOAD_TYPE_ERROR = 'UPLOAD_TYPE_ERROR',
  TRANSACTION_ID_ERROR = 'TRANSACTION_ID_ERROR',
  UPLOAD_TO_ROOT_ERROR = 'UPLOAD_TO_ROOT_ERROR',
  UPLOAD_TO_FOUND_ERROR = 'UPLOAD_TO_FOUND_ERROR',
  UPLOAD_TO_FILE_ERROR = 'UPLOAD_TO_FILE_ERROR',
  FILE_UPLOAD_TO_WORKSPACE_ERROR = 'FILE_UPLOAD_TO_WORKSPACE_ERROR',
  UPLOAD_SESSION_FILE_DIRECT_TO_WORKSPACE = 'UPLOAD_SESSION_FILE_DIRECT_TO_WORKSPACE',
  UPLOAD_SESSION_INVALID_TRANSITION = 'UPLOAD_SESSION_INVALID_TRANSITION',
  UPLOAD_SESSION_TERMINAL_STATE = 'UPLOAD_SESSION_TERMINAL_STATE',
  UPLOAD_SESSION_STATUS_NOT_SUPPORTED = 'UPLOAD_SESSION_STATUS_NOT_SUPPORTED',
  UPLOAD_SESSION_NOT_EDITABLE = 'UPLOAD_SESSION_NOT_EDITABLE',
  UPLOAD_SESSION_EMPTY_MANIFEST = 'UPLOAD_SESSION_EMPTY_MANIFEST',
  UPLOAD_SESSION_MANIFEST_INVALID = 'UPLOAD_SESSION_MANIFEST_INVALID',
  UPLOAD_SESSION_PATH_CONFLICT = 'UPLOAD_SESSION_PATH_CONFLICT',
  UPLOAD_SESSION_NOT_FOUND = 'UPLOAD_SESSION_NOT_FOUND',
  UPLOAD_SESSION_PERMISSION_DENIED = 'UPLOAD_SESSION_PERMISSION_DENIED',
  UPLOAD_SESSION_INVALID_CLIENT_HINTS = 'UPLOAD_SESSION_INVALID_CLIENT_HINTS',
  UPLOAD_SESSION_INVALID_STATUS_FILTER = 'UPLOAD_SESSION_INVALID_STATUS_FILTER',
  UPLOAD_SESSION_INVALID_PARENT = 'UPLOAD_SESSION_INVALID_PARENT',
  FILE_UPLOAD_LIMIT_ERROR = 'FILE_UPLOAD_LIMIT_EXCEED_ERROR',
  NO_FILES_ATTACHED_ERROR = 'NO_FILES_ATTACHED_ERROR',
  FILE_STORAGE_WRITE_ERROR = 'FILE_STORAGE_WRITE_ERROR',
  FILE_STORAGE_READ_ERROR = 'FILE_STORAGE_READ_ERROR',
  BLOB_WRITE_ERROR = 'BLOB_WRITE_ERROR',
  REQUESTED_RESOURCE_NOT_FILE = 'REQUESTED_RESOURCE_NOT_FILE',
  FILE_STORAGE_DELETE_ERROR = 'FILE_STORAGE_DELETE_ERROR',
  PUBLIC_FOLDER_DELETE_ERROR = 'PUBLIC_FOLDER_DELETE_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_ARGS = 'INVALID_ARGS',
  INVALID_ITEM = 'INVALID_ITEM',
  FOLDER_NOT_ALLOWED_HERE = 'FOLDER_NOT_ALLOWED_HERE',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
  READ_ONLY_RESOURCE_UPDATE = 'READ_ONLY_RESOURCE_UPDATE',
  READ_ONLY_RESOURCE_DELETE = 'READ_ONLY_RESOURCE_DELETE',
  ADD_PERMISSIONS_AGAINST_RESOURCE_ERROR = 'ADD_PERMISSIONS_AGAINST_RESOURCE_ERROR',
  PERMISSIONS_UPDATING_ERROR_FOR_ROLE = 'PERMISSIONS_UPDATING_ERROR_FOR_ROLE',
  INSUFFICIENT_VIEW_PRIVILEGES = 'INSUFFICIENT_VIEW_PRIVILEGES',
  INSUFFICIENT_CREATE_PRIVILEGES = 'INSUFFICIENT_CREATE_PRIVILEGES',
  INSUFFICIENT_UPDATE_PRIVILEGES = 'INSUFFICIENT_UPDATE_PRIVILEGES',
  INSUFFICIENT_DELETE_PRIVILEGES = 'INSUFFICIENT_DELETE_PRIVILEGES',
  INSUFFICIENT_DELETE_ONE_OR_MORE_PRIVILEGES = 'INSUFFICIENT_DELETE_ONE_OR_MORE_PRIVILEGES',
  WA_CREATE_USER_RESTRICTION = 'WA_CREATE_USER_RESTRICTION',
  INSUFFICIENT_ASSIGNMENT_PRIVILEGES = 'INSUFFICIENT_ASSIGNMENT_PRIVILEGES',
  OA_REMOVAL_FROM_RESOURCE_DENIED = 'OA_REMOVAL_FROM_RESOURCE_DENIED',
  PEER_ACCOUNT_ASSIGNMENT_RESTRICTION = 'PEER_ACCOUNT_ASSIGNMENT_RESTRICTION',
  RU_ASSIGNMENT_AS_CONTROLLER_RESTRICTION = 'RU_ASSIGNMENT_AS_CONTROLLER_RESTRICTION',
  SELF_ASSIGNMENT_ON_RESOURCE_RESTRICTION = 'SELF_ASSIGNMENT_ON_RESOURCE_RESTRICTION',
  MESSAGE_ON_EMPTY_FOLDER_OR_UNAVAILABLE_FILE = 'MESSAGE_ON_EMPTY_FOLDER_OR_UNAVAILABLE_FILE',
  NO_SHARED_FILES_EXIST = 'NO_SHARED_FILES_EXIST',
  AD_USER_NOT_FOUND = 'AD_USER_NOT_FOUND',
  OPERATION_NOT_PERMITTED = 'OPERATION_NOT_PERMITTED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  ROLE_ASSIGNED_CANNOT_DELETE = 'ROLE_ASSIGNED_CANNOT_DELETE',
  ROLE_ALREADY_EXISTS_ERROR = 'ROLE_ALREADY_EXISTS_ERROR',
  ITEM_DETAILS_NOT_FOUND = 'ITEM_DETAILS_NOT_FOUND',
  CHAT_CREDIT_LIMIT_EXCEEDED = 'CHAT_CREDIT_LIMIT_EXCEEDED',
  FILE_CREDIT_LIMIT_EXCEEDED = 'FILE_CREDIT_LIMIT_EXCEEDED',
  FILE_WORD_LIMIT_EXCEEDED = 'FILE_WORD_LIMIT_EXCEEDED',
  CREDIT_LIMIT_EXCEEDED_90_PERCENT = 'CREDIT_LIMIT_EXCEEDED_MORE_THEN_90',
  CREDIT_LIMIT_REACHED_100_PERCENT = 'CREDIT_LIMIT_EXCEEDED_MORE_THEN_100',
  PAYG_CREDIT_LIMIT_EXCEEDED_90_PERCENT = 'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_90',
  PAYG_CREDIT_LIMIT_REACHED_100_PERCENT = 'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_100',
  WORD_LIMIT_EXCEEDED_90_PERCENT = 'WORD_LIMIT_EXCEEDED_MORE_THEN_90',
  WORD_LIMIT_REACHED_100_PERCENT = 'WORD_LIMIT_EXCEEDED_MORE_THEN_100',
  FAVOURITE_ADD_ERROR = 'FAVOURITE_ADD_ERROR',
  FAVOURITE_REMOVE_ERROR = 'FAVOURITE_REMOVE_ERROR',
  USER_FAVOURITE_LIMIT_REACHED = 'USER_FAVOURITE_LIMIT_REACHED',
  USER_INVITE_LIMIT_REACHED = 'USER_INVITE_LIMIT_REACHED',
  NO_RESOURCES_SHARED = 'NO_RESOURCES_SHARED',
  CONTENT_FILTER = 'CONTENT_FILTER',
  GENERAL_AI_ERROR = 'GENERAL_ERROR',
  COULD_NOT_INITIATE_REQUEST = 'CHAT_INITIATION_ERROR',
  UNSUPPORTED_LANGUAGE = 'UNSUPPORTED_LANGUAGE',
  TENANT_CREATION_FAILED = 'TENANT_CREATION_FAILED',
  TENANT_UPDATE_FAILED = 'TENANT_UPDATE_FAILED',
  TENANT_DELETE_FAILED = 'TENANT_DELETE_FAILED',
  TENANT_FILE_REPROCESS_FAILED = 'TENANT_FILE_REPROCESS_FAILED',
  NO_AUTHORISED_FILES = 'NO_AUTHORISED_FILES',
  REFERENCE_DOCUMENT_DELETED = 'REFERENCE_DOCUMENT_DELETED',
  MAXIMUM_DATASET_FILES_LIMIT = 'MAXIMUM_DATASET_FILES_LIMIT',
  QUESTIONNAIRE_BLOCKED_DUE_TO_ASSOCIATION = 'QUESTIONNAIRE_BLOCKED_DUE_TO_ASSOCIATION',
  DOCUMENT_ANALYSIS_JOB_FAILED = 'DOCUMENT_ANALYSIS_JOB_FAILED',
  DOCUMENT_ANALYSIS_RESOURCE_NOT_FOUND = 'DOCUMENT_ANALYSIS_RESOURCE_NOT_FOUND',
  MAX_RUNNING_ANALYSIS_LIMIT = 'MAX_RUNNING_ANALYSIS_LIMIT',
  MAX_LIMIT_EXCEEDED = 'MAX_LIMIT_EXCEEDED',
  ANALYSIS_EDITING_BLOCKED = 'ANALYSIS_EDITING_BLOCKED',
  MINIMUM_DATASET_FILES_LIMIT = 'MINIMUM_DATASET_FILES_LIMIT',
  ANALYSIS_TO_QUESTIONNAIRE_UPDATE_LIMIT = 'ANALYSIS_TO_QUESTIONNAIRE_UPDATE_LIMIT',
  IMAGE_GENERATION_LIMIT_REACHED = 'IMAGE_GENERATION_LIMIT_REACHED',
  RATE_LIMIT = '429',
  ASSISTANT_INFO_NOT_FOUND = 'ASSISTANT_INFO_NOT_FOUND',
  IMPORT_NOT_ALLOWED = 'IMPORT_NOT_ALLOWED',
  SP_SITE_PERMISSION_DENIED = 'SP_SITE_PERMISSION_DENIED',
  IMAGE_ANALYSIS_NOT_SUPPORTED = 'IMAGE_ANALYSIS_NOT_SUPPORTED',
  CHAT_NOT_FOUND_ERROR = 'CHAT_NOT_FOUND_ERROR',
  SUPPORT_TICKET_CREATION_ERROR = 'SUPPORT_TICKET_CREATION_ERROR',
  WORD_CREDIT_UPDATE_ERROR = 'WORD_CREDIT_UPDATE_ERROR',
  EXEMPTED_TOKENS = 'EXEMPTED_TOKENS',
  CHAT_COUNT_RESOURCE_FETCH_ERROR = 'CHAT_COUNT_RESOURCE_FETCH_ERROR',
  USER_TIME_WINDOW_LIMIT_FOR_CHAT_EXCEEDED = 'USER_TIME_WINDOW_LIMIT_FOR_CHAT_EXCEEDED',
  USER_TIME_WINDOW_LIMIT_FOR_DOC_ANALYSIS_EXCEEDED = 'USER_TIME_WINDOW_LIMIT_FOR_DOC_ANALYSIS_EXCEEDED',
  CONTEXT_LENGTH_EXCEEDED = 'CONTEXT_LENGTH_EXCEEDED',
  CONTENT_POLICY_VIOLATION = 'CONTENT_POLICY_VIOLATION',
  ASSISTANT_RESOURCE_NOT_FOUND = 'ASSISTANT_RESOURCE_NOT_FOUND',
  LOGO_UPDATE_FAILED = 'LOGO_UPDATE_FAILED',
  LOGO_DELETE_FAILED = 'LOGO_DELETE_FAILED',
  ERROR_UPDATING_CANVAS = 'ERROR_UPDATING_CANVAS',
  INVALID_CREDENTIALS_ERROR = 'INVALID_CREDENTIALS_ERROR',
  SEAT_NOT_AVAILABLE_ERROR = 'SEAT_NOT_AVAILABLE_ERROR',
  DOMAIN_NOT_RESOLVED_ERROR = 'DOMAIN_NOT_RESOLVED_ERROR',
  USER_ALREADY_EXISTS_ERROR = 'USER_ALREADY_EXISTS_ERROR',
  INVALID_SUBSCRIPTION = 'INVALID_SUBSCRIPTION',
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  SUBSCRIPTION_SYNCING_ERROR = 'SUBSCRIPTION_SYNCING_ERROR',
  SUBSCRIPTION_UPDATE_ERROR = 'SUBSCRIPTION_UPDATE_ERROR',
  PREVIEW_INVOICE_ERROR = 'PREVIEW_INVOICE_ERROR',
  TAX_LOCATION_INVALID = 'TAX_LOCATION_INVALID',
  NO_UPCOMING_INVOICE = 'NO_UPCOMING_INVOICE',
  INSUFFICIENT_CARD_BALANCE_ERROR = 'INSUFFICIENT_CARD_BALANCE_ERROR',
  END_TRIAL_ERROR = 'END_TRIAL_ERROR',
  CARD_ACTION_REQUIRED_ERROR = 'CARD_ACTION_REQUIRED_ERROR',
  CARD_DECLINED_ERROR = 'CARD_DECLINED_ERROR',
  CARD_EXPIRED_ERROR = 'CARD_EXPIRED_ERROR',
  PAYMENT_FAILED_ERROR = 'PAYMENT_FAILED_ERROR',
  ADDON_NOT_ELIGIBLE_ERROR = 'ADDON_NOT_ELIGIBLE_ERROR',
  ADDON_ALREADY_ACTIVE_ERROR = 'ADDON_ALREADY_ACTIVE_ERROR',
  ADDON_NOT_FOUND_ERROR = 'ADDON_NOT_FOUND_ERROR',
  ADDON_PURCHASE_ERROR = 'ADDON_PURCHASE_ERROR',
  ADDON_CANCEL_ERROR = 'ADDON_CANCEL_ERROR',
  STRIPE_TENANT_NOT_FOUND_ERROR = 'STRIPE_TENANT_NOT_FOUND_ERROR',
  TENANT_DOMAIN_ALREADY_EXISTS_ERROR = 'TENANT_DOMAIN_ALREADY_EXISTS_ERROR',
  TENANT_NOT_FOUND_ERROR = 'TENANT_NOT_FOUND_ERROR',
  ACTIVE_SUBSCRIPTION_ALREADY_EXISTS_ERROR = 'ACTIVE_SUBSCRIPTION_ALREADY_EXISTS_ERROR',
  TRIAL_ALREADY_END_ERROR = 'TRIAL_ALREADY_END_ERROR',
  INVALID_PAYMENT_ARGS_ERROR = 'INVALID_PAYMENT_ARGS_ERROR',
  SUBSCRIPTION_RENEWAL_ERROR = 'SUBSCRIPTION_RENEWAL_ERROR',
  SUBSCRIPTION_RENEWAL_NOT_ALLOWED_ERROR = 'SUBSCRIPTION_RENEWAL_NOT_ALLOWED_ERROR',
  SUBSCRIPTION_UPDATE_NOT_ALLOWED_ERROR = 'SUBSCRIPTION_UPDATE_NOT_ALLOWED_ERROR',
  SUBSCRIPTION_OPERATION_NOT_ALLOWED_ERROR = 'SUBSCRIPTION_OPERATION_NOT_ALLOWED_ERROR',
  SUBSCRIPTION_UPGRADE_ERROR = 'SUBSCRIPTION_UPGRADE_ERROR',
  MINIMUM_SEATS_VIOLATION_ERROR = 'MINIMUM_SEATS_VIOLATION_ERROR',
  MAXIMUM_SEATS_VIOLATION_ERROR = 'MAXIMUM_SEATS_VIOLATION_ERROR',
  SUBSCRIPTION_UPGRADE_NOT_ALLOWED_ERROR = 'SUBSCRIPTION_UPGRADE_NOT_ALLOWED_ERROR',
  ANALYSIS_QUESTION_LIMIT_REACHED = 'ANALYSIS_QUESTION_LIMIT_REACHED',
  PAYMENT_PLAN_CREATION_FAILED = 'PAYMENT_PLAN_CREATION_FAILED',
  PAYMENT_PLAN_ALREADY_EXIST = 'PAYMENT_PLAN_ALREADY_EXIST',
  PAYMENT_PLAN_UPDATE_FAILED = 'PAYMENT_PLAN_UPDATE_FAILED',
  SMART_MEET_LICENSE_REACHED = 'SMART_MEET_LICENSE_REACHED',
  TRANSCRIPTION_GENERATION_ERROR = 'TRANSCRIPTION_GENERATION_ERROR',
  ERROR_UPDATING_MODEL = 'ERROR_UPDATING_MODEL',
  ERROR_GETTING_MODEL = 'ERROR_GETTING_MODEL',
  ERROR_CONFIGURING_MODEL = 'ERROR_CONFIGURING_MODEL',
  CONFIGURING_CHAT_MODEL = 'CONFIGURING_CHAT_MODEL',
  CONFIGURING_MODEL_PROPERTIES = 'CONFIGURING_MODEL_PROPERTIES',
  PROJECT_NAME_ALREADY_EXISTS_ERROR = 'PROJECT_NAME_ALREADY_EXISTS_ERROR',
  WORKFLOW_NAME_ALREADY_EXISTS_ERROR = 'WORKFLOW_NAME_ALREADY_EXISTS_ERROR',
  WORKFLOW_CREDIT_LIMIT_EXCEEDED = 'WORKFLOW_CREDIT_LIMIT_EXCEEDED',
  WORKFLOW_RUNS_LIMIT_EXCEEDED = 'WORKFLOW_RUNS_LIMIT_EXCEEDED',
  WORKFLOW_TRIGGER_TYPE_NOT_SUPPORTED = 'WORKFLOW_TRIGGER_TYPE_NOT_SUPPORTED',
  WORKFLOW_TEAMS_CHANNEL_IDS_REQUIRED = 'WORKFLOW_TEAMS_CHANNEL_IDS_REQUIRED',
  WORKFLOW_TEAMS_TEAM_ID_IS_CONVERSATION_ID = 'WORKFLOW_TEAMS_TEAM_ID_IS_CONVERSATION_ID',
  WORKFLOW_TEAMS_INVALID_TEAM_ID = 'WORKFLOW_TEAMS_INVALID_TEAM_ID',
  WORKFLOW_TEAMS_INVALID_CHANNEL_ID = 'WORKFLOW_TEAMS_INVALID_CHANNEL_ID',
  WORKFLOW_TEAMS_CHAT_ID_REQUIRED = 'WORKFLOW_TEAMS_CHAT_ID_REQUIRED',
  WORKFLOW_TEAMS_INVALID_CHAT_ID = 'WORKFLOW_TEAMS_INVALID_CHAT_ID',
  WORKFLOW_TEAMS_CHANNEL_NOT_FOUND = 'WORKFLOW_TEAMS_CHANNEL_NOT_FOUND',
  WORKFLOW_TEAMS_CHANNEL_ACCESS_DENIED = 'WORKFLOW_TEAMS_CHANNEL_ACCESS_DENIED',
  WORKFLOW_TEAMS_CHAT_NOT_FOUND = 'WORKFLOW_TEAMS_CHAT_NOT_FOUND',
  WORKFLOW_TEAMS_CHAT_ACCESS_DENIED = 'WORKFLOW_TEAMS_CHAT_ACCESS_DENIED',
  WORKFLOW_INVALID_SEARCH_QUERY = 'WORKFLOW_INVALID_SEARCH_QUERY',
  PAYG_ALREADY_EXISTS_ERROR = 'PAYG_ALREADY_EXISTS_ERROR',
  PAYG_INVALID_LIMIT_ERROR = 'PAYG_INVALID_LIMIT_ERROR',
  PAYG_NOT_ENABLED_ERROR = 'PAYG_NOT_ENABLED_ERROR',
  NOTIFICATION_FETCH_ERROR = 'NOTIFICATION_FETCH_ERROR',
  NOTIFICATION_MARK_ALL_READ_ERROR = 'NOTIFICATION_MARK_ALL_READ_ERROR',
  NOTIFICATION_READ_STATUS_UPDATE_ERROR = 'NOTIFICATION_READ_STATUS_UPDATE_ERROR',
  NOTIFICATION_DISMISS_ERROR = 'NOTIFICATION_DISMISS_ERROR',
  NOTIFICATION_DISMISS_ALL_ERROR = 'NOTIFICATION_DISMISS_ALL_ERROR',
  NOTIFICATION_PREFERENCES_FETCH_ERROR = 'NOTIFICATION_PREFERENCES_FETCH_ERROR',
  NOTIFICATION_PREFERENCES_UPDATE_ERROR = 'NOTIFICATION_PREFERENCES_UPDATE_ERROR',
  NOTIFICATION_MANDATORY_CATEGORY_ERROR = 'NOTIFICATION_MANDATORY_CATEGORY_ERROR',
  SKILL_NAME_ALREADY_EXISTS_ERROR = 'SKILL_NAME_ALREADY_EXISTS_ERROR',
  SKILL_NAME_EXISTS_AS_DEPRECATED = 'SKILL_NAME_EXISTS_AS_DEPRECATED',
  SKILL_ZIP_REQUIRED = 'SKILL_ZIP_REQUIRED',
  SKILL_ZIP_VALIDATION_ERROR = 'SKILL_ZIP_VALIDATION_ERROR',
  SKILL_PUBLICATION_ERROR = 'SKILL_PUBLICATION_ERROR',
  SKILL_NOT_REGISTERED_IN_DOCLM_ERROR = 'SKILL_NOT_REGISTERED_IN_DOCLM_ERROR',
  SKILL_ZIP_MISSING_SKILL_FILE = 'SKILL_ZIP_MISSING_SKILL_FILE',
  SKILL_ZIP_MULTIPLE_SKILLS_ERROR = 'SKILL_ZIP_MULTIPLE_SKILLS_ERROR',
  SKILL_ZIP_UNSAFE_ERROR = 'SKILL_ZIP_UNSAFE_ERROR',
  SKILL_ZIP_INVALID_PACKAGE_ERROR = 'SKILL_ZIP_INVALID_PACKAGE_ERROR',
  SKILL_DISABLED_BY_OWNER = 'SKILL_DISABLED_BY_OWNER',
  SKILL_PUBLICATION_JUDGE_FAILED = 'SKILL_PUBLICATION_JUDGE_FAILED',
  SKILL_NOT_INSTALLED_BY_OWNER = 'SKILL_NOT_INSTALLED_BY_OWNER'
}

export enum ErrorContext {
  FILES = 'files',
  USERS = 'users',
  CHAT = 'chat',
  ROLES = 'roles',
  USER_ROLES = 'userRoles',
  TENANTS = 'tenants',
  USER_GROUPS = 'userGroups',
  GENERAL = 'general',
  RESOURCE_PROVIDER = 'resourceProvider',
  OA = 'OA',
  FAVOURITES = 'favourites',
  AI = 'ai',
  DOC_ANALYST = 'docAnalyst',
  ASSISTANT = 'Assistant',
  SMART_MEET = 'SmartMeet',
  PROJECT = 'Project',
  ICONS = 'Icons',
  HELP_SUPPORT = 'Hel&Support',
  WORD_CREDIT = 'WordCredit',
  ORG_LOGO = 'OrgLogo',
  CHAT_COUNT = 'ChatCount',
  CANVAS = 'canvas',
  IDENTITY_PROVIDER = 'identityProvider',
  BILLINGS = 'billings',
  SELF_SIGN_UP = 'selfSignUp',
  SUBSCRIPTION = 'subscription',
  MODELS = 'models',
  WORKFLOW_CREATE = 'workflowcreate',
  SKILLS = 'skills',
  WORKFLOW = 'workflow',
  WORKFLOW_FORM = 'workflowForm',
  WORKFLOW_TRIGGER = 'workflowTrigger',
  PAYG = 'payg',
  NOTIFICATIONS = 'notifications'
}

export const ErrorMessages = {
  [ErrorContext.FILES]: {
    [ErrorCodes.NAMESPACE_ERROR]: T.namespaceError,
    [ErrorCodes.NO_PERMISSIONS_AGAINST_RESOURCE_ERROR]:
      T.noPermissionsAgainstResourceError,
    [ErrorCodes.INSUFFICIENT_PRIVILEGES]: T.insufficientPrivileges,
    [ErrorCodes.APP_ROLE_TEMPLATE_NOT_FOUND_ERROR]:
      T.appRoleTemplateNotFoundError,
    [ErrorCodes.UPLOAD_TYPE_ERROR]: T.uploadTypeError,
    [ErrorCodes.TRANSACTION_ID_ERROR]: T.transactionIdError,
    [ErrorCodes.UPLOAD_TO_ROOT_ERROR]: T.uploadToRootError,
    [ErrorCodes.UPLOAD_TO_FOUND_ERROR]: T.uploadToFoundError,
    [ErrorCodes.UPLOAD_TO_FILE_ERROR]: T.uploadToFileError,
    [ErrorCodes.FILE_UPLOAD_TO_WORKSPACE_ERROR]: T.fileUploadToWorkspaceError,
    [ErrorCodes.UPLOAD_SESSION_FILE_DIRECT_TO_WORKSPACE]:
      T.uploadSessionFileDirectToWorkspaceError,
    [ErrorCodes.UPLOAD_SESSION_INVALID_TRANSITION]:
      T.uploadSessionInvalidTransition,
    [ErrorCodes.UPLOAD_SESSION_TERMINAL_STATE]: T.uploadSessionTerminalState,
    [ErrorCodes.UPLOAD_SESSION_STATUS_NOT_SUPPORTED]:
      T.uploadSessionStatusNotSupported,
    [ErrorCodes.UPLOAD_SESSION_NOT_EDITABLE]: T.uploadSessionNotEditable,
    [ErrorCodes.UPLOAD_SESSION_EMPTY_MANIFEST]: T.uploadSessionEmptyManifest,
    [ErrorCodes.UPLOAD_SESSION_MANIFEST_INVALID]:
      T.uploadSessionManifestInvalid,
    [ErrorCodes.UPLOAD_SESSION_PATH_CONFLICT]: T.uploadSessionPathConflict,
    [ErrorCodes.UPLOAD_SESSION_NOT_FOUND]: T.uploadSessionNotFound,
    [ErrorCodes.UPLOAD_SESSION_PERMISSION_DENIED]:
      T.uploadSessionPermissionDenied,
    [ErrorCodes.UPLOAD_SESSION_INVALID_CLIENT_HINTS]:
      T.uploadSessionInvalidClientHints,
    [ErrorCodes.UPLOAD_SESSION_INVALID_STATUS_FILTER]:
      T.uploadSessionInvalidStatusFilter,
    [ErrorCodes.UPLOAD_SESSION_INVALID_PARENT]: T.uploadSessionInvalidParent,
    [ErrorCodes.NO_FILES_ATTACHED_ERROR]: T.noFilesAttachedError,
    [ErrorCodes.FILE_STORAGE_WRITE_ERROR]: T.fileStorageWriteError,
    [ErrorCodes.FILE_STORAGE_READ_ERROR]: T.fileStorageReadError,
    [ErrorCodes.BLOB_WRITE_ERROR]: T.blobWriteError,
    [ErrorCodes.REQUESTED_RESOURCE_NOT_FILE]: T.requestedResourceNotFile,
    [ErrorCodes.FILE_STORAGE_DELETE_ERROR]: T.fileStorageDeleteError,
    [ErrorCodes.PUBLIC_FOLDER_DELETE_ERROR]: T.publicFolderDeleteError,
    [ErrorCodes.FOLDER_NOT_ALLOWED_HERE]: T.folderNotAllowedHere,
    [ErrorCodes.SELF_ASSIGNMENT_ON_RESOURCE_RESTRICTION]:
      T.selfAssignmentOnResourceRestriction,
    [ErrorCodes.RU_ASSIGNMENT_AS_CONTROLLER_RESTRICTION]:
      T.ruAssignmentAsControllerRestriction,
    [ErrorCodes.OA_REMOVAL_FROM_RESOURCE_DENIED]: T.oaRemovalFromResourceDenied,
    [ErrorCodes.INSUFFICIENT_ASSIGNMENT_PRIVILEGES]:
      T.insufficientAssignmentPrivileges,
    [ErrorCodes.PEER_ACCOUNT_ASSIGNMENT_RESTRICTION]:
      T.peerAccountAssignmentRestriction,
    [ErrorCodes.ITEM_DETAILS_NOT_FOUND]: T.itemDetailsNotFoundError,
    [ErrorCodes.UNIQUE_VIOLATION]: T.uniqueResourceNameError,
    [ErrorCodes.FILE_CREDIT_LIMIT_EXCEEDED]: T.fileCreditLimitExceeded,
    [ErrorCodes.FILE_WORD_LIMIT_EXCEEDED]: T.fileWordLimitExceeded,
    [ErrorCodes.REFERENCE_DOCUMENT_DELETED]: T.referenceDocumentDeleted,
    [ErrorCodes.IMPORT_NOT_ALLOWED]: T.importNotAllowed,
    [ErrorCodes.SP_SITE_PERMISSION_DENIED]: T.spSitePermissionDenied,

    [ErrorContext.OA]: {
      [ErrorCodes.FILE_CREDIT_LIMIT_EXCEEDED]: T.fileCreditLimitExceededOA,
      [ErrorCodes.FILE_WORD_LIMIT_EXCEEDED]: T.fileWordLimitExceededOA
    },
    [ErrorCodes.FILE_UPLOAD_LIMIT_ERROR]: T.fileUploadLimitError
  },
  [ErrorContext.ROLES]: {
    [ErrorCodes.INSUFFICIENT_VIEW_PRIVILEGES]:
      T.rolesInsufficientViewPrivileges,
    [ErrorCodes.UNIQUE_VIOLATION]: T.rolesUniqueVoilation,
    [ErrorCodes.PERMISSIONS_UPDATING_ERROR_FOR_ROLE]:
      T.permissionsUpdatingErrorForRole
  },
  [ErrorContext.USER_ROLES]: {
    [ErrorCodes.ROLE_ALREADY_EXISTS_ERROR]: T.userRoleAlreadyExists,
    [ErrorCodes.ROLE_ASSIGNED_CANNOT_DELETE]: T.userRoleAssignedCannotDelete
  },
  [ErrorContext.TENANTS]: {
    [ErrorCodes.TENANT_CREATION_FAILED]: T.tenantCreationFailed,
    [ErrorCodes.TENANT_UPDATE_FAILED]: T.tenantPlanUpdateFail,
    [ErrorCodes.TENANT_DELETE_FAILED]: T.tenantDeletionFailed,
    [ErrorCodes.TENANT_FILE_REPROCESS_FAILED]: T.tenantFileReprocessingFailed,
    [ErrorCodes.UNIQUE_VIOLATION]: T.tenantUniqueViolation,
    [ErrorCodes.PAYMENT_PLAN_CREATION_FAILED]: T.paymentPlanCreationFailed,
    [ErrorCodes.PAYMENT_PLAN_ALREADY_EXIST]: T.paymentPlanAlreadyExist,
    [ErrorCodes.PAYMENT_PLAN_UPDATE_FAILED]: T.paymentPlanUpdateFailed,
    [ErrorCodes.TENANT_NOT_FOUND_ERROR]: T.searchTenantNotFoundError,
    [ErrorCodes.TENANT_DOMAIN_ALREADY_EXISTS_ERROR]:
      T.tenantDomainAlreadyExistsError
  },
  [ErrorContext.USER_GROUPS]: {
    [ErrorCodes.INSUFFICIENT_VIEW_PRIVILEGES]:
      T.userGroupsInsufficientPrivileges,
    [ErrorCodes.UNIQUE_VIOLATION]: T.userGroupUniqueVoilation
  },
  [ErrorContext.USERS]: {
    [ErrorCodes.WA_CREATE_USER_RESTRICTION]: T.waCreateUserRestriction,
    [ErrorCodes.UNIQUE_VIOLATION]: T.usersUniqueVoilation,
    [ErrorCodes.AD_USER_NOT_FOUND]: T.adUserNotFoundError
  },
  [ErrorContext.CHAT]: {
    [ErrorCodes.MESSAGE_ON_EMPTY_FOLDER_OR_UNAVAILABLE_FILE]:
      T.messageOnEmptyFolderOrUnavailableFile,
    [ErrorCodes.NO_SHARED_FILES_EXIST]: T.noSharedFilesExist,
    [ErrorCodes.CHAT_CREDIT_LIMIT_EXCEEDED]: T.chatCreditLimitExceeded,
    [ErrorContext.OA]: {
      [ErrorCodes.CHAT_CREDIT_LIMIT_EXCEEDED]: T.chatCreditLimitExceededOA
    },
    [ErrorCodes.ASSISTANT_RESOURCE_NOT_FOUND]: T.assistantResourceNotFound,
    [ErrorCodes.NO_RESOURCES_SHARED]: T.noResourcesShared,
    [ErrorCodes.COULD_NOT_INITIATE_REQUEST]: T.chatInitiationError,
    [ErrorCodes.ASSISTANT_INFO_NOT_FOUND]: T.assistantDeletedError,
    [ErrorCodes.IMAGE_ANALYSIS_NOT_SUPPORTED]: T.imageAnalysisNotSupported,
    [ErrorCodes.CHAT_NOT_FOUND_ERROR]: T.chatDeleted,
    [ErrorCodes.IMAGE_GENERATION_LIMIT_REACHED]: T.imageGenerationLimitReached
  },
  [ErrorContext.GENERAL]: {
    // Email trigger search_query rejected on connect or save.
    [ErrorCodes.WORKFLOW_INVALID_SEARCH_QUERY]: T.wfInvalidSearchQuery,
    [ErrorCodes.CREDIT_LIMIT_EXCEEDED_90_PERCENT]:
      'CREDIT_LIMIT_EXCEEDED_MORE_THEN_90',
    [ErrorCodes.CREDIT_LIMIT_REACHED_100_PERCENT]:
      'CREDIT_LIMIT_EXCEEDED_MORE_THEN_100',
    [ErrorCodes.PAYG_CREDIT_LIMIT_EXCEEDED_90_PERCENT]:
      'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_90',
    [ErrorCodes.PAYG_CREDIT_LIMIT_REACHED_100_PERCENT]:
      'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_100',
    [ErrorCodes.INTERNAL_SERVER_ERROR]: T.internalServerError,
    [ErrorCodes.USER_LICENSE_EXPIRED]: T.licenseExpiredMessage,
    [ErrorCodes.RESOURCE_NOT_FOUND_ERROR]: T.resourceNotFoundError,
    [ErrorCodes.USER_NOT_FOUND]: T.userNotFoundError,
    [ErrorCodes.INVALID_ARGS]: T.invalidArgsError,
    [ErrorCodes.READ_ONLY_RESOURCE_DELETE]: T.readOnlyResourceDelete,
    [ErrorCodes.ADD_PERMISSIONS_AGAINST_RESOURCE_ERROR]:
      T.addPermissionsAgainstResourceError,
    [ErrorCodes.INSUFFICIENT_CREATE_PRIVILEGES]: T.insufficientCreatePrivileges,
    [ErrorCodes.INSUFFICIENT_UPDATE_PRIVILEGES]: T.insufficientUpdatePrivileges,
    [ErrorCodes.INSUFFICIENT_DELETE_PRIVILEGES]: T.insufficientDeletePrivileges,
    [ErrorCodes.INSUFFICIENT_DELETE_ONE_OR_MORE_PRIVILEGES]:
      T.insufficientDeleteOneOrMorePrivileges,
    [ErrorCodes.READ_ONLY_RESOURCE_UPDATE]: T.readOnlyResourceUpdate,
    [ErrorCodes.SEAT_NOT_AVAILABLE_ERROR]: T.seatsNotAvailable,
    [ErrorCodes.USER_INVITE_LIMIT_REACHED]: T.userInviteLimitReachedError
  },
  [ErrorContext.RESOURCE_PROVIDER]: {
    [ErrorCodes.OPERATION_NOT_PERMITTED]: T.operationNotPermitted,
    [ErrorCodes.INSUFFICIENT_PRIVILEGES]: T.insufficientPrivileges,
    [ErrorCodes.INVALID_CREDENTIALS_ERROR]: T.invalidCredentialsError
  },
  [ErrorContext.IDENTITY_PROVIDER]: {
    [ErrorCodes.INVALID_CREDENTIALS_ERROR]: T.invalidCredentialsError
  },
  [ErrorContext.FAVOURITES]: {
    [ErrorCodes.FAVOURITE_ADD_ERROR]: T.markFavouriteError,
    [ErrorCodes.FAVOURITE_REMOVE_ERROR]: T.unmarkFavouriteError,
    [ErrorCodes.USER_FAVOURITE_LIMIT_REACHED]: T.favouriteLimitReached
  },
  [ErrorContext.ICONS]: {
    [ErrorCodes.USER_LICENSE_EXPIRED]: T.licenseExpiredMessage
  },
  [ErrorContext.AI]: {
    [ErrorCodes.CONTENT_FILTER]: T.contentFilteringErrorMsg,
    [ErrorCodes.GENERAL_AI_ERROR]: T.generalErrorMsg,
    [ErrorCodes.UNSUPPORTED_LANGUAGE]: T.unsupportedLanguage,
    [ErrorCodes.RATE_LIMIT]: T.rateLimit,
    [ErrorCodes.NO_AUTHORISED_FILES]: T.noAuthorizedFilesForChat,
    [ErrorCodes.CONTEXT_LENGTH_EXCEEDED]: T.chatContextLengthExceed,
    [ErrorCodes.CONTENT_POLICY_VIOLATION]: T.contentPolicyViolation
  },
  [ErrorContext.DOC_ANALYST]: {
    [ErrorCodes.MAXIMUM_DATASET_FILES_LIMIT]: T.maximumDatasetSize,
    [ErrorCodes.QUESTIONNAIRE_BLOCKED_DUE_TO_ASSOCIATION]:
      T.questionnaireBlocked,
    [ErrorCodes.DOCUMENT_ANALYSIS_JOB_FAILED]: T.analysisFailed,
    [ErrorCodes.DOCUMENT_ANALYSIS_RESOURCE_NOT_FOUND]:
      T.analysisResourceFailure,
    [ErrorCodes.MAX_RUNNING_ANALYSIS_LIMIT]: T.analysisLimit,
    [ErrorCodes.ANALYSIS_EDITING_BLOCKED]: T.analysisEditingBlocked,
    [ErrorCodes.MINIMUM_DATASET_FILES_LIMIT]: T.minimumDatasetSize,
    [ErrorCodes.ANALYSIS_TO_QUESTIONNAIRE_UPDATE_LIMIT]:
      T.analysisQuestionnaireUpdateLimit,
    [ErrorCodes.UNIQUE_VIOLATION]: T.docAnalystDuplicationError,
    [ErrorCodes.USER_TIME_WINDOW_LIMIT_FOR_DOC_ANALYSIS_EXCEEDED]:
      T.docAnalystUsageLimitReached,
    [ErrorCodes.ANALYSIS_QUESTION_LIMIT_REACHED]:
      T.analysisQuestionLimitReached,
    [ErrorCodes.MAX_LIMIT_EXCEEDED]: T.maxLimitExceeded
  },
  [ErrorContext.SMART_MEET]: {
    [ErrorCodes.SMART_MEET_LICENSE_REACHED]: `${T.failedToCreate}. ${T.licenseLimitReached}`,
    [ErrorCodes.TRANSCRIPTION_GENERATION_ERROR]: T.transcriptionGenerationError,
    [ErrorCodes.BLOB_WRITE_ERROR]: T.blobWriteError
  },
  [ErrorContext.PROJECT]: {
    [ErrorCodes.PROJECT_NAME_ALREADY_EXISTS_ERROR]: T.projectNameAlreadyExists
  },
  // Shared by create, rename and detail edits — all reject duplicate names.
  [ErrorContext.WORKFLOW]: {
    [ErrorCodes.WORKFLOW_NAME_ALREADY_EXISTS_ERROR]: T.wfNameAlreadyExists,
    [ErrorCodes.WORKFLOW_CREDIT_LIMIT_EXCEEDED]: T.wfCreditLimitExceeded,
    [ErrorCodes.WORKFLOW_RUNS_LIMIT_EXCEEDED]: T.wfRunsLimitExceeded
  },
  // The hosted trigger form is used by people outside the builder: a failed
  // run there is a failed form submission, so the generic "Something went
  // wrong." of the GENERAL map is overridden with form wording.
  [ErrorContext.WORKFLOW_FORM]: {
    [ErrorCodes.WORKFLOW_CREDIT_LIMIT_EXCEEDED]: T.wfCreditLimitExceeded,
    [ErrorCodes.WORKFLOW_RUNS_LIMIT_EXCEEDED]: T.wfRunsLimitExceeded,
    [ErrorCodes.INTERNAL_SERVER_ERROR]: T.wfFormSubmitFailed
  },
  // Trigger subscription (POST /subscription) — Teams channel/chat id checks
  // and Graph rejections of well-formed ids.
  [ErrorContext.WORKFLOW_TRIGGER]: {
    [ErrorCodes.WORKFLOW_TRIGGER_TYPE_NOT_SUPPORTED]:
      T.wfTriggerTypeNotSupported,
    [ErrorCodes.WORKFLOW_TEAMS_CHANNEL_IDS_REQUIRED]:
      T.wfTeamsChannelIdsRequired,
    [ErrorCodes.WORKFLOW_TEAMS_TEAM_ID_IS_CONVERSATION_ID]:
      T.wfTeamsTeamIdIsConversationId,
    [ErrorCodes.WORKFLOW_TEAMS_INVALID_TEAM_ID]: T.wfTeamsInvalidTeamId,
    [ErrorCodes.WORKFLOW_TEAMS_INVALID_CHANNEL_ID]: T.wfTeamsInvalidChannelId,
    [ErrorCodes.WORKFLOW_TEAMS_CHAT_ID_REQUIRED]: T.wfTeamsChatIdRequired,
    [ErrorCodes.WORKFLOW_TEAMS_INVALID_CHAT_ID]: T.wfTeamsInvalidChatId,
    [ErrorCodes.WORKFLOW_TEAMS_CHANNEL_NOT_FOUND]: T.wfTeamsChannelNotFound,
    [ErrorCodes.WORKFLOW_TEAMS_CHANNEL_ACCESS_DENIED]:
      T.wfTeamsChannelAccessDenied,
    [ErrorCodes.WORKFLOW_TEAMS_CHAT_NOT_FOUND]: T.wfTeamsChatNotFound,
    [ErrorCodes.WORKFLOW_TEAMS_CHAT_ACCESS_DENIED]: T.wfTeamsChatAccessDenied
  },
  [ErrorContext.ASSISTANT]: {
    [ErrorCodes.UNIQUE_VIOLATION]: T.assistantUniqueViolationError,
    [ErrorCodes.OPERATION_NOT_PERMITTED]: T.operationNotPermitted,
    [ErrorCodes.PERMISSION_DENIED]: T.operationNotPermitted,
    [ErrorCodes.PEER_ACCOUNT_ASSIGNMENT_RESTRICTION]:
      T.peerAccountAssignmentRestriction,
    [ErrorCodes.SELF_ASSIGNMENT_ON_RESOURCE_RESTRICTION]:
      T.assistantSelfAssignmentError
  },
  [ErrorContext.HELP_SUPPORT]: {
    [ErrorCodes.SUPPORT_TICKET_CREATION_ERROR]: T.supportTicketError
  },
  [ErrorContext.WORD_CREDIT]: {
    [ErrorCodes.WORD_CREDIT_UPDATE_ERROR]: T.creditUsageError
  },
  [ErrorContext.ORG_LOGO]: {
    [ErrorCodes.LOGO_UPDATE_FAILED]: T.logoUpdatedError,
    [ErrorCodes.LOGO_DELETE_FAILED]: T.logoDeletedError
  },
  [ErrorContext.CHAT_COUNT]: {
    [ErrorCodes.CHAT_COUNT_RESOURCE_FETCH_ERROR]: T.fetchResourceCountError
  },
  [ErrorContext.CANVAS]: {
    [ErrorCodes.ERROR_UPDATING_CANVAS]: T.errorUpdatingCanvas
  },
  [ErrorContext.SELF_SIGN_UP]: {
    [ErrorCodes.SEAT_NOT_AVAILABLE_ERROR]: T.seatsNotAvailable,
    [ErrorCodes.DOMAIN_NOT_RESOLVED_ERROR]: T.domainBlocked,
    [ErrorCodes.USER_ALREADY_EXISTS_ERROR]: T.userAlreadyExist,
    [ErrorCodes.INTERNAL_SERVER_ERROR]: T.internalServerError,
    [ErrorCodes.STRIPE_TENANT_NOT_FOUND_ERROR]: T.stripeTenantNotFoundError,
    [ErrorCodes.TENANT_DOMAIN_ALREADY_EXISTS_ERROR]:
      T.tenantDomainAlreadyExistsError
  },
  [ErrorContext.SUBSCRIPTION]: {
    [ErrorCodes.INVALID_SUBSCRIPTION]: T.invalidSubscription,
    [ErrorCodes.SUBSCRIPTION_NOT_FOUND]: T.noSubscription,
    [ErrorCodes.SUBSCRIPTION_SYNCING_ERROR]: T.subscriptionSyncError,
    [ErrorCodes.SUBSCRIPTION_UPDATE_ERROR]: T.errorUpdatingSubscription,
    [ErrorCodes.PREVIEW_INVOICE_ERROR]: T.unableToPreviewInvoice,
    [ErrorCodes.TAX_LOCATION_INVALID]: T.wrongAddress,
    [ErrorCodes.NO_UPCOMING_INVOICE]: T.subscriptionCancelledText,
    [ErrorCodes.INSUFFICIENT_CARD_BALANCE_ERROR]: T.insufficientBalance,
    [ErrorCodes.END_TRIAL_ERROR]: T.endTrialError,
    [ErrorCodes.CARD_ACTION_REQUIRED_ERROR]: T.cardActionRequiredError,
    [ErrorCodes.CARD_EXPIRED_ERROR]: T.cardExpiredError,
    [ErrorCodes.PAYMENT_FAILED_ERROR]: T.paymentFailedError,
    [ErrorCodes.STRIPE_TENANT_NOT_FOUND_ERROR]: T.stripeTenantNotFoundError,
    [ErrorCodes.ACTIVE_SUBSCRIPTION_ALREADY_EXISTS_ERROR]:
      T.activeSubscriptionAlreadyExistsError,
    [ErrorCodes.TRIAL_ALREADY_END_ERROR]: T.trialAlreadyExpired,
    [ErrorCodes.INVALID_PAYMENT_ARGS_ERROR]: T.invalidArgsError,
    [ErrorCodes.SUBSCRIPTION_RENEWAL_ERROR]: T.subscriptionUpdateError,
    [ErrorCodes.SUBSCRIPTION_RENEWAL_NOT_ALLOWED_ERROR]:
      T.subscriptionRenewalNotAllowed,
    [ErrorCodes.SUBSCRIPTION_UPDATE_NOT_ALLOWED_ERROR]:
      T.subscriptionUpdateNotAllowed,
    [ErrorCodes.SUBSCRIPTION_OPERATION_NOT_ALLOWED_ERROR]:
      T.subscriptionUpdateNotAllowed,
    [ErrorCodes.SUBSCRIPTION_UPGRADE_ERROR]: T.subscriptionUpgradeFailed,
    [ErrorCodes.MINIMUM_SEATS_VIOLATION_ERROR]: T.minimumSeatsViolation,
    [ErrorCodes.MAXIMUM_SEATS_VIOLATION_ERROR]: T.maximumSeatsViolation,
    [ErrorCodes.SUBSCRIPTION_UPGRADE_NOT_ALLOWED_ERROR]:
      T.subscriptionUpdateNotAllowed,
    [ErrorCodes.CARD_DECLINED_ERROR]: T.cardExpiredError,
    [ErrorCodes.ADDON_NOT_ELIGIBLE_ERROR]: T.addOnNotEligibleError,
    [ErrorCodes.ADDON_ALREADY_ACTIVE_ERROR]: T.addOnAlreadyActiveError,
    [ErrorCodes.ADDON_NOT_FOUND_ERROR]: T.addOnNotFoundError,
    [ErrorCodes.ADDON_PURCHASE_ERROR]: T.addOnPurchaseError,
    [ErrorCodes.ADDON_CANCEL_ERROR]: T.addOnCancelError
  },
  [ErrorContext.PAYG]: {
    [ErrorCodes.PAYG_ALREADY_EXISTS_ERROR]: T.paygAlreadyExists,
    [ErrorCodes.PAYG_INVALID_LIMIT_ERROR]: T.paygInvalidLimit,
    [ErrorCodes.PAYG_NOT_ENABLED_ERROR]: T.paygNotEnabled,
    [ErrorCodes.PAYG_CREDIT_LIMIT_EXCEEDED_90_PERCENT]:
      'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_90',
    [ErrorCodes.PAYG_CREDIT_LIMIT_REACHED_100_PERCENT]:
      'PAYG_CREDIT_LIMIT_EXCEEDED_MORE_THEN_100'
  },
  [ErrorContext.MODELS]: {
    [ErrorCodes.ERROR_UPDATING_MODEL]: T.defaultModelUpdateError,
    [ErrorCodes.ERROR_GETTING_MODEL]: T.errorGettingModel,
    [ErrorCodes.ERROR_CONFIGURING_MODEL]: T.errorConfiguringModel,
    [ErrorCodes.CONFIGURING_CHAT_MODEL]: T.errorConfiguringChatModel,
    [ErrorCodes.CONFIGURING_MODEL_PROPERTIES]: T.errorConfiguringModelProperties
  },
  [ErrorContext.NOTIFICATIONS]: {
    [ErrorCodes.NOTIFICATION_FETCH_ERROR]: T.notificationFetchError,
    [ErrorCodes.NOTIFICATION_MARK_ALL_READ_ERROR]:
      T.notificationMarkAllReadError,
    [ErrorCodes.NOTIFICATION_READ_STATUS_UPDATE_ERROR]:
      T.notificationReadStatusUpdateError,
    [ErrorCodes.NOTIFICATION_DISMISS_ERROR]: T.notificationDismissError,
    [ErrorCodes.NOTIFICATION_DISMISS_ALL_ERROR]: T.notificationDismissAllError,
    [ErrorCodes.NOTIFICATION_PREFERENCES_FETCH_ERROR]:
      T.notificationPreferencesFetchError,
    [ErrorCodes.NOTIFICATION_PREFERENCES_UPDATE_ERROR]:
      T.notificationPreferencesUpdateError,
    [ErrorCodes.NOTIFICATION_MANDATORY_CATEGORY_ERROR]:
      T.notificationMandatoryCategoryError
  },
  [ErrorContext.SKILLS]: {
    [ErrorCodes.SKILL_NAME_ALREADY_EXISTS_ERROR]: T.skillNameAlreadyExistsError,
    [ErrorCodes.SKILL_NAME_EXISTS_AS_DEPRECATED]:
      T.skillNameExistsAsDeprecatedError,
    [ErrorCodes.SKILL_ZIP_REQUIRED]: T.skillZipRequired,
    [ErrorCodes.SKILL_ZIP_VALIDATION_ERROR]: T.skillZipValidationError,
    [ErrorCodes.SKILL_PUBLICATION_ERROR]: T.skillPublicationError,
    [ErrorCodes.SKILL_NOT_REGISTERED_IN_DOCLM_ERROR]:
      T.skillNotRegisteredInDocLMError,
    [ErrorCodes.SKILL_ZIP_MISSING_SKILL_FILE]: T.skillZipMissingSkillFileError,
    [ErrorCodes.SKILL_ZIP_MULTIPLE_SKILLS_ERROR]: T.skillZipMultipleSkillsError,
    [ErrorCodes.SKILL_ZIP_UNSAFE_ERROR]: T.skillZipUnsafeError,
    [ErrorCodes.SKILL_ZIP_INVALID_PACKAGE_ERROR]: T.skillZipInvalidPackageError,
    [ErrorCodes.SKILL_DISABLED_BY_OWNER]: T.skillDisabledByOwnerError,
    [ErrorCodes.SKILL_PUBLICATION_JUDGE_FAILED]:
      T.skillPublicationJudgeFailedError,
    [ErrorCodes.SKILL_NOT_INSTALLED_BY_OWNER]: T.skillNotInstalledByOwnerError
  }
};

export const WarningCodes = new Set<string>([
  ErrorCodes.SKILL_ZIP_VALIDATION_ERROR,
  ErrorCodes.SKILL_ZIP_MISSING_SKILL_FILE,
  ErrorCodes.SKILL_ZIP_MULTIPLE_SKILLS_ERROR,
  ErrorCodes.SKILL_ZIP_UNSAFE_ERROR,
  ErrorCodes.SKILL_ZIP_INVALID_PACKAGE_ERROR,
  ErrorCodes.SKILL_NAME_ALREADY_EXISTS_ERROR,
  ErrorCodes.SKILL_NAME_EXISTS_AS_DEPRECATED
]);
